
export const DEFAULTPATH = '/victorysoft/wellreport/wellreport_01'
window.DEFAULTPATH = DEFAULTPATH

export function getDefaultData() {
    return ''
}